<script setup lang="ts" generic="T extends string">
import { computed } from 'vue'

import { Selector } from '../../'

const props = defineProps<{
  options: { id: number; label: string; value: T }[]
  placeholder: string
  size?: 'default' | 'large'
  isDisabled?: boolean
}>()

const model = defineModel<T | null>({ default: null })

const selectedOption = computed(() => props.options.find((option) => option.value === model.value) ?? null)

const handleSelection = (item: { id: number; label?: string } | null) => {
  const selected = item ? props.options.find((option) => option.id === item.id) : undefined
  model.value = selected?.value ?? null
}
</script>

<template>
  <Selector
    :size="size"
    :is-disabled="isDisabled"
    :options="options"
    :selected-option="selectedOption"
    :selected-label="selectedOption?.label ?? placeholder"
    :show-search="false"
    should-truncate-text
    :truncate-option-text="false"
    @update:selected-option="handleSelection"
  />
</template>
